// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"242e1461","209":"97d4d49f","277":"115c3d17","330":"f601f003","549":"bcbecc73","585":"12f3d26d","619":"9f9cc51e","629":"4840dac2","722":"bb9e1e5d","736":"5acc5b4f","756":"67ac2c2c","863":"84e0f73c","887":"4b8cd097","926":"aa46c28d"}[chunkId] + ".chunk.js";
};